import { add } from './add';
import { alertClose } from './alertClose';
import { clearSearch } from './clearSearch';
import { createApiKey } from './createApiKey';
import { deleteApiKey } from './deleteApiKey';
import { remove } from './remove';
import { findAll } from './findAll';
import { findOne } from './findOne';
import { search } from './search';
import { searchHosts } from './searchHosts';
import { update } from './update';
import { userClear } from './userClear';

export const userActions = {
  add,
  alertClose,
  clearSearch,
  createApiKey,
  deleteApiKey,
  findAll,
  findOne,
  remove,
  search,
  searchHosts,
  update,
  userClear,
};
